import { css } from 'styled-components';
import { StyledTheme, responsive } from '../../../../styles';
export const CampaignBaseStyles = css<{ theme: StyledTheme }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-bottom: 1rem;
  padding: 0.25rem;
  background-color: ${({ theme }) => theme.palette.productBackground.color};

  .campaign-image {
    flex-basis: 20%;
    padding: 0.5rem;

    img {
      width: 100%;

      ${responsive.desktop.small(css`
        width: 75%;
      `)}
    }
  }

  .campaign-text {
    flex-basis: 80%;

    .campaign-title {
      font-weight: bold;
      font-size: 0.95rem;
      color: ${({ theme }) => theme.palette.primary.color};
    }

    .campaign-message {
      font-family: ${({ theme }) => theme.typography.mainFontFamilyLight};
      font-size: 0.85rem;
      color: ${({ theme }) => theme.palette.primary.color};
    }
  }
`;
